import { checkMatchPath } from '~/utils/path-helpers';
import { useMemo } from 'react';

const useShouldShowModal = ({
  includeModalPaths,
  modal,
  pathname,
}: {
  includeModalPaths: string[];
  modal: Queries.ModalFragmentFragment | undefined;
  pathname: string;
}) => {
  const shouldShowModal = useMemo(
    () => !!modal && includeModalPaths.some((path) => checkMatchPath(path, pathname)),
    [includeModalPaths, pathname, modal]
  );

  return shouldShowModal;
};

export default useShouldShowModal;
